import styled from 'styled-components'

export const Layout = styled.div`
  position: relative;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    'info info info info'
    'summary1 summary2 summary3 summary4';
  column-gap: 8px;

  > :nth-child(1) {
    grid-area: info;
  }

  > :nth-child(2) {
    grid-area: summary1;
  }

  > :nth-child(3) {
    grid-area: summary2;
  }

  > :nth-child(4) {
    grid-area: summary3;
  }

  > :nth-child(5) {
    grid-area: summary4;
  }
`

export const Description = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 1rem;
  color: ${props => props.theme.colors.color545e6c};
  white-space: break-spaces;
`

export const YearSummary = styled.div<{ isAltered: boolean }>`
  position: relative;
  width: 100%;
  background: ${props => (props.isAltered ? props.theme.colors.colorFFE9E9 : props.theme.colors.colore6f4e7)};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  padding: 4px;
`

export const EmptySummary = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.colorf3f5f9};
  border-radius: ${({ theme }) => theme.zds.border.radius100};

  font-family: 'Inter';
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: ${props => props.theme.colors.color6b7786};
`

export const Year = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Result = styled.p`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: ${props => props.theme.colors.color545e6c};
  text-align: right;
`
